import React from "react";
import { CLIENT_PLANT_INFO } from "../../constants/updateClientContants";
import UpdateClientProfilesWrapper from "../../container/UpdateClientProfilesWrapper/UpdateClientProfilesWrapper";

const UpdateClientPlantInfo = () => (
  <UpdateClientProfilesWrapper bodyContent={CLIENT_PLANT_INFO} />
);

export default UpdateClientPlantInfo;
